export const convertToLowerCase = (value: string) => value?.toLowerCase();
